import { HttpClient } from '@angular/common/http';

export class ApiMethodConfiguration {
    path: string;
    method: string;
    headers: object;
}

export class ConfigurationServiceAPIConfiguration {

    getPortalConfiguration: ApiMethodConfiguration = {
        path: '/api/config/',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };

    createPortalConfiguration: ApiMethodConfiguration = {
        path: '/api/config/',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };

    editPortalConfiguration: ApiMethodConfiguration = {
        path: '/api/config/',
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };

    deletePortalConfiguration: ApiMethodConfiguration = {
        path: '/api/config/',
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };
    constructor(public baseUrl: string, public httpClient: HttpClient) { }

}
